import andTrTR from 'antd/es/locale/tr_TR';
import enMsg from "../locales/tr_TR.json";

const TrLang = {
  antd: andTrTR,
  locale: 'tr-TR',
  messages: {
    ...enMsg
  },
};
export default TrLang;
